const AISENSY_WCC_PLAN = {
  business_initiated: {
    AF: {
      INR: 602000,
      USD: 9080,
    },
    AL: {
      INR: 673000,
      USD: 10120,
    },
    DZ: {
      INR: 967000,
      USD: 14440,
    },
    AO: {
      INR: 967000,
      USD: 14440,
    },
    AR: {
      INR: 430000,
      USD: 6540,
    },
    AM: {
      INR: 673000,
      USD: 10120,
    },
    AU: {
      INR: 602000,
      USD: 9080,
    },
    AT: {
      INR: 1058000,
      USD: 15790,
    },
    AZ: {
      INR: 673000,
      USD: 10120,
    },
    BH: {
      INR: 588000,
      USD: 8870,
    },
    BD: {
      INR: 602000,
      USD: 9080,
    },
    BY: {
      INR: 673000,
      USD: 10120,
    },
    BE: {
      INR: 1058000,
      USD: 15790,
    },
    BJ: {
      INR: 967000,
      USD: 14440,
    },
    BO: {
      INR: 572000,
      USD: 8630,
    },
    BW: {
      INR: 967000,
      USD: 14440,
    },
    BR: {
      INR: 409000,
      USD: 6240,
    },
    BG: {
      INR: 673000,
      USD: 10120,
    },
    BF: {
      INR: 967000,
      USD: 14440,
    },
    BI: {
      INR: 967000,
      USD: 14440,
    },
    KH: {
      INR: 602000,
      USD: 9080,
    },
    CA: {
      INR: 572000,
      USD: 8630,
    },
    CM: {
      INR: 967000,
      USD: 14440,
    },
    TD: {
      INR: 967000,
      USD: 14440,
    },
    CL: {
      INR: 612000,
      USD: 9220,
    },
    CN: {
      INR: 602000,
      USD: 9080,
    },
    CO: {
      INR: 95000,
      USD: 1610,
    },
    CG: {
      INR: 396000,
      USD: 6050,
    },
    CR: {
      INR: 572000,
      USD: 8630,
    },
    HR: {
      INR: 673000,
      USD: 10120,
    },
    CZ: {
      INR: 673000,
      USD: 10120,
    },
    DK: {
      INR: 1058000,
      USD: 15790,
    },
    VE: {
      INR: 572000,
      USD: 8630,
    },
    EC: {
      INR: 572000,
      USD: 8630,
    },
    EG: {
      INR: 861000,
      USD: 12880,
    },
    SV: {
      INR: 572000,
      USD: 8630,
    },
    ER: {
      INR: 967000,
      USD: 14440,
    },
    ET: {
      INR: 967000,
      USD: 14440,
    },
    FI: {
      INR: 1058000,
      USD: 15790,
    },
    FR: {
      INR: 1143000,
      USD: 17040,
    },
    GA: {
      INR: 967000,
      USD: 14440,
    },
    GM: {
      INR: 967000,
      USD: 14440,
    },
    GE: {
      INR: 673000,
      USD: 10120,
    },
    DE: {
      INR: 1091000,
      USD: 16260,
    },
    GH: {
      INR: 967000,
      USD: 14440,
    },
    GR: {
      INR: 673000,
      USD: 10120,
    },
    GT: {
      INR: 572000,
      USD: 8630,
    },
    GW: {
      INR: 967000,
      USD: 14440,
    },
    HT: {
      INR: 572000,
      USD: 8630,
    },
    HN: {
      INR: 572000,
      USD: 8630,
    },
    HK: {
      INR: 602000,
      USD: 9080,
    },
    HU: {
      INR: 673000,
      USD: 10120,
    },
    IN: {
      INR: 55000,
      USD: 800,
    },
    ID: {
      INR: 265000,
      USD: 4110,
    },
    IQ: {
      INR: 588000,
      USD: 8870,
    },
    IE: {
      INR: 1058000,
      USD: 15790,
    },
    IL: {
      INR: 252000,
      USD: 3930,
    },
    IT: {
      INR: 522000,
      USD: 7900,
    },
    JP: {
      INR: 602000,
      USD: 9080,
    },
    JO: {
      INR: 588000,
      USD: 8870,
    },
    KE: {
      INR: 967000,
      USD: 14440,
    },
    KW: {
      INR: 588000,
      USD: 8870,
    },
    LA: {
      INR: 602000,
      USD: 9080,
    },
    LV: {
      INR: 673000,
      USD: 10120,
    },
    LB: {
      INR: 588000,
      USD: 8870,
    },
    LS: {
      INR: 967000,
      USD: 14440,
    },
    LR: {
      INR: 967000,
      USD: 14440,
    },
    LY: {
      INR: 967000,
      USD: 14440,
    },
    LT: {
      INR: 673000,
      USD: 10120,
    },
    MG: {
      INR: 967000,
      USD: 14440,
    },
    MW: {
      INR: 967000,
      USD: 14440,
    },
    MY: {
      INR: 592000,
      USD: 8930,
    },
    ML: {
      INR: 967000,
      USD: 14440,
    },
    MR: {
      INR: 967000,
      USD: 14440,
    },
    MX: {
      INR: 291000,
      USD: 4490,
    },
    MD: {
      INR: 673000,
      USD: 10120,
    },
    MN: {
      INR: 602000,
      USD: 9080,
    },
    MA: {
      INR: 967000,
      USD: 14440,
    },
    MZ: {
      INR: 967000,
      USD: 14440,
    },
    NA: {
      INR: 967000,
      USD: 14440,
    },
    NP: {
      INR: 602000,
      USD: 9080,
    },
    NL: {
      INR: 1185000,
      USD: 17650,
    },
    NZ: {
      INR: 602000,
      USD: 9080,
    },
    NI: {
      INR: 572000,
      USD: 8630,
    },
    NE: {
      INR: 967000,
      USD: 14440,
    },
    NG: {
      INR: 422000,
      USD: 6430,
    },
    NO: {
      INR: 1058000,
      USD: 15790,
    },
    OM: {
      INR: 588000,
      USD: 8870,
    },
    PK: {
      INR: 388000,
      USD: 5930,
    },
    PA: {
      INR: 572000,
      USD: 8630,
    },
    PG: {
      INR: 602000,
      USD: 9080,
    },
    PY: {
      INR: 572000,
      USD: 8630,
    },
    PE: {
      INR: 487000,
      USD: 7380,
    },
    PH: {
      INR: 602000,
      USD: 9080,
    },
    PL: {
      INR: 673000,
      USD: 10120,
    },
    PT: {
      INR: 1058000,
      USD: 15790,
    },
    PR: {
      INR: 572000,
      USD: 8630,
    },
    QA: {
      INR: 588000,
      USD: 8870,
    },
    RO: {
      INR: 673000,
      USD: 10120,
    },
    RU: {
      INR: 538000,
      USD: 8130,
    },
    RW: {
      INR: 967000,
      USD: 14440,
    },
    SA: {
      INR: 272000,
      USD: 4220,
    },
    SN: {
      INR: 967000,
      USD: 14440,
    },
    RS: {
      INR: 673000,
      USD: 10120,
    },
    SL: {
      INR: 967000,
      USD: 14440,
    },
    SG: {
      INR: 602000,
      USD: 9080,
    },
    SK: {
      INR: 673000,
      USD: 10120,
    },
    SI: {
      INR: 673000,
      USD: 10120,
    },
    SO: {
      INR: 967000,
      USD: 14440,
    },
    ZA: {
      INR: 236000,
      USD: 3690,
    },
    SS: {
      INR: 967000,
      USD: 14440,
    },
    ES: {
      INR: 500000,
      USD: 7570,
    },
    LK: {
      INR: 602000,
      USD: 9080,
    },
    SD: {
      INR: 967000,
      USD: 14440,
    },
    SE: {
      INR: 1058000,
      USD: 15790,
    },
    CH: {
      INR: 1058000,
      USD: 15790,
    },
    TW: {
      INR: 602000,
      USD: 9080,
    },
    TJ: {
      INR: 602000,
      USD: 9080,
    },
    TH: {
      INR: 602000,
      USD: 9080,
    },
    TG: {
      INR: 967000,
      USD: 14440,
    },
    TN: {
      INR: 967000,
      USD: 14440,
    },
    TR: {
      INR: 95000,
      USD: 1610,
    },
    TM: {
      INR: 602000,
      USD: 9080,
    },
    UG: {
      INR: 967000,
      USD: 14440,
    },
    UA: {
      INR: 673000,
      USD: 10120,
    },
    AE: {
      INR: 265000,
      USD: 4110,
    },
    GB: {
      INR: 525000,
      USD: 7950,
    },
    US: {
      INR: 572000,
      USD: 8630,
    },
    UY: {
      INR: 572000,
      USD: 8630,
    },
    UZ: {
      INR: 602000,
      USD: 9080,
    },
    VN: {
      INR: 602000,
      USD: 9080,
    },
    YE: {
      INR: 588000,
      USD: 8870,
    },
    ZM: {
      INR: 967000,
      USD: 14440,
    },
    TZ: {
      INR: 967000,
      USD: 14440,
    },
    SZ: {
      INR: 967000,
      USD: 14440,
    },
    MK: {
      INR: 673000,
      USD: 10120,
    },
    DO: {
      INR: 572000,
      USD: 8630,
    },
    JM: {
      INR: 572000,
      USD: 8630,
    },
    CI: {
      INR: 967000,
      USD: 14440,
    },
    OTHER: {
      INR: 396000,
      USD: 6050,
    },
    KZ: {
      INR: 396000,
      USD: 6050,
    },
    ZW: {
      INR: 396000,
      USD: 6050,
    },
  },
  user_initiated: {
    AF: {
      INR: 192000,
      USD: 2830,
    },
    AL: {
      INR: 213000,
      USD: 3130,
    },
    DZ: {
      INR: 302000,
      USD: 4440,
    },
    AO: {
      INR: 302000,
      USD: 4440,
    },
    AR: {
      INR: 265000,
      USD: 3890,
    },
    AM: {
      INR: 213000,
      USD: 3130,
    },
    AU: {
      INR: 192000,
      USD: 2830,
    },
    AT: {
      INR: 328000,
      USD: 4830,
    },
    AZ: {
      INR: 213000,
      USD: 3130,
    },
    BH: {
      INR: 187000,
      USD: 2760,
    },
    BD: {
      INR: 192000,
      USD: 2830,
    },
    BY: {
      INR: 213000,
      USD: 3130,
    },
    BE: {
      INR: 328000,
      USD: 4830,
    },
    BJ: {
      INR: 302000,
      USD: 4440,
    },
    BO: {
      INR: 349000,
      USD: 5130,
    },
    BW: {
      INR: 302000,
      USD: 4440,
    },
    BR: {
      INR: 252000,
      USD: 3710,
    },
    BG: {
      INR: 213000,
      USD: 3130,
    },
    BF: {
      INR: 302000,
      USD: 4440,
    },
    BI: {
      INR: 302000,
      USD: 4440,
    },
    KH: {
      INR: 192000,
      USD: 2830,
    },
    CA: {
      INR: 349000,
      USD: 5130,
    },
    CM: {
      INR: 302000,
      USD: 4440,
    },
    TD: {
      INR: 302000,
      USD: 4440,
    },
    CL: {
      INR: 373000,
      USD: 5490,
    },
    CN: {
      INR: 192000,
      USD: 2830,
    },
    CO: {
      INR: 63000,
      USD: 930,
    },
    CG: {
      INR: 130000,
      USD: 1910,
    },
    CR: {
      INR: 349000,
      USD: 5130,
    },
    HR: {
      INR: 213000,
      USD: 3130,
    },
    CZ: {
      INR: 213000,
      USD: 3130,
    },
    DK: {
      INR: 328000,
      USD: 4830,
    },
    VE: {
      INR: 349000,
      USD: 5130,
    },
    EC: {
      INR: 349000,
      USD: 5130,
    },
    EG: {
      INR: 523000,
      USD: 7690,
    },
    SV: {
      INR: 349000,
      USD: 5130,
    },
    ER: {
      INR: 302000,
      USD: 4440,
    },
    ET: {
      INR: 302000,
      USD: 4440,
    },
    FI: {
      INR: 328000,
      USD: 4830,
    },
    FR: {
      INR: 692000,
      USD: 10180,
    },
    GA: {
      INR: 302000,
      USD: 4440,
    },
    GM: {
      INR: 302000,
      USD: 4440,
    },
    GE: {
      INR: 213000,
      USD: 3130,
    },
    DE: {
      INR: 661000,
      USD: 9720,
    },
    GH: {
      INR: 302000,
      USD: 4440,
    },
    GR: {
      INR: 213000,
      USD: 3130,
    },
    GT: {
      INR: 349000,
      USD: 5130,
    },
    GW: {
      INR: 302000,
      USD: 4440,
    },
    HT: {
      INR: 349000,
      USD: 5130,
    },
    HN: {
      INR: 349000,
      USD: 5130,
    },
    HK: {
      INR: 192000,
      USD: 2830,
    },
    HU: {
      INR: 213000,
      USD: 3130,
    },
    IN: {
      INR: 35000,
      USD: 510,
    },
    ID: {
      INR: 165000,
      USD: 2430,
    },
    IQ: {
      INR: 187000,
      USD: 2760,
    },
    IE: {
      INR: 328000,
      USD: 4830,
    },
    IL: {
      INR: 157000,
      USD: 2320,
    },
    IT: {
      INR: 320000,
      USD: 4700,
    },
    JP: {
      INR: 192000,
      USD: 2830,
    },
    JO: {
      INR: 187000,
      USD: 2760,
    },
    KE: {
      INR: 302000,
      USD: 4440,
    },
    KW: {
      INR: 187000,
      USD: 2760,
    },
    LA: {
      INR: 192000,
      USD: 2830,
    },
    LV: {
      INR: 213000,
      USD: 3130,
    },
    LB: {
      INR: 187000,
      USD: 2760,
    },
    LS: {
      INR: 302000,
      USD: 4440,
    },
    LR: {
      INR: 302000,
      USD: 4440,
    },
    LY: {
      INR: 302000,
      USD: 4440,
    },
    LT: {
      INR: 213000,
      USD: 3130,
    },
    MG: {
      INR: 302000,
      USD: 4440,
    },
    MW: {
      INR: 302000,
      USD: 4440,
    },
    MY: {
      INR: 189000,
      USD: 2780,
    },
    ML: {
      INR: 302000,
      USD: 4440,
    },
    MR: {
      INR: 302000,
      USD: 4440,
    },
    MX: {
      INR: 98000,
      USD: 1450,
    },
    MD: {
      INR: 213000,
      USD: 3130,
    },
    MN: {
      INR: 192000,
      USD: 2830,
    },
    MA: {
      INR: 302000,
      USD: 4440,
    },
    MZ: {
      INR: 302000,
      USD: 4440,
    },
    NA: {
      INR: 302000,
      USD: 4440,
    },
    NP: {
      INR: 192000,
      USD: 2830,
    },
    NL: {
      INR: 717000,
      USD: 10550,
    },
    NZ: {
      INR: 192000,
      USD: 2830,
    },
    NI: {
      INR: 349000,
      USD: 5130,
    },
    NE: {
      INR: 302000,
      USD: 4440,
    },
    NG: {
      INR: 260000,
      USD: 3820,
    },
    NO: {
      INR: 328000,
      USD: 4830,
    },
    OM: {
      INR: 187000,
      USD: 2760,
    },
    PK: {
      INR: 128000,
      USD: 1880,
    },
    PA: {
      INR: 349000,
      USD: 5130,
    },
    PG: {
      INR: 192000,
      USD: 2830,
    },
    PY: {
      INR: 349000,
      USD: 5130,
    },
    PE: {
      INR: 157000,
      USD: 2300,
    },
    PH: {
      INR: 192000,
      USD: 2830,
    },
    PL: {
      INR: 213000,
      USD: 3130,
    },
    PT: {
      INR: 328000,
      USD: 4830,
    },
    PR: {
      INR: 349000,
      USD: 5130,
    },
    QA: {
      INR: 187000,
      USD: 2760,
    },
    RO: {
      INR: 213000,
      USD: 3130,
    },
    RU: {
      INR: 329000,
      USD: 4840,
    },
    RW: {
      INR: 302000,
      USD: 4440,
    },
    SA: {
      INR: 169000,
      USD: 2490,
    },
    SN: {
      INR: 302000,
      USD: 4440,
    },
    RS: {
      INR: 213000,
      USD: 3130,
    },
    SL: {
      INR: 302000,
      USD: 4440,
    },
    SG: {
      INR: 192000,
      USD: 2830,
    },
    SK: {
      INR: 213000,
      USD: 3130,
    },
    SI: {
      INR: 213000,
      USD: 3130,
    },
    SO: {
      INR: 302000,
      USD: 4440,
    },
    ZA: {
      INR: 148000,
      USD: 2180,
    },
    SS: {
      INR: 302000,
      USD: 4440,
    },
    ES: {
      INR: 306000,
      USD: 4500,
    },
    LK: {
      INR: 192000,
      USD: 2830,
    },
    SD: {
      INR: 302000,
      USD: 4440,
    },
    SE: {
      INR: 328000,
      USD: 4830,
    },
    CH: {
      INR: 328000,
      USD: 4830,
    },
    TW: {
      INR: 192000,
      USD: 2830,
    },
    TJ: {
      INR: 192000,
      USD: 2830,
    },
    TH: {
      INR: 192000,
      USD: 2830,
    },
    TG: {
      INR: 302000,
      USD: 4440,
    },
    TN: {
      INR: 302000,
      USD: 4440,
    },
    TR: {
      INR: 39000,
      USD: 580,
    },
    TM: {
      INR: 192000,
      USD: 2830,
    },
    UG: {
      INR: 302000,
      USD: 4440,
    },
    UA: {
      INR: 213000,
      USD: 3130,
    },
    AE: {
      INR: 165000,
      USD: 2430,
    },
    GB: {
      INR: 321000,
      USD: 4730,
    },
    US: {
      INR: 349000,
      USD: 5130,
    },
    UY: {
      INR: 349000,
      USD: 5130,
    },
    UZ: {
      INR: 192000,
      USD: 2830,
    },
    VN: {
      INR: 192000,
      USD: 2830,
    },
    YE: {
      INR: 187000,
      USD: 2760,
    },
    ZM: {
      INR: 302000,
      USD: 4440,
    },
    TZ: {
      INR: 302000,
      USD: 4440,
    },
    SZ: {
      INR: 302000,
      USD: 4440,
    },
    MK: {
      INR: 213000,
      USD: 3130,
    },
    DO: {
      INR: 349000,
      USD: 5130,
    },
    JM: {
      INR: 349000,
      USD: 5130,
    },
    CI: {
      INR: 302000,
      USD: 4440,
    },
    OTHER: {
      INR: 130000,
      USD: 1910,
    },
    KZ: {
      INR: 130000,
      USD: 1910,
    },
    ZW: {
      INR: 130000,
      USD: 1910,
    },
  },
  service: {
    AF: {
      INR: 104602,
      USD: 1356,
    },
    AL: {
      INR: 195715,
      USD: 2544,
    },
    DZ: {
      INR: 37006,
      USD: 480,
    },
    AO: {
      INR: 37006,
      USD: 480,
    },
    AR: {
      INR: 240754,
      USD: 3120,
    },
    AM: {
      INR: 195715,
      USD: 2544,
    },
    AU: {
      INR: 104602,
      USD: 1356,
    },
    AT: {
      INR: 158078,
      USD: 2052,
    },
    AZ: {
      INR: 195715,
      USD: 2544,
    },
    BH: {
      INR: 84179,
      USD: 1092,
    },
    BD: {
      INR: 34253,
      USD: 444,
    },
    BY: {
      INR: 195715,
      USD: 2544,
    },
    BE: {
      INR: 158078,
      USD: 2052,
    },
    BJ: {
      INR: 37006,
      USD: 480,
    },
    BO: {
      INR: 104552,
      USD: 1356,
    },
    BW: {
      INR: 37006,
      USD: 480,
    },
    BR: {
      INR: 62948,
      USD: 816,
    },
    BG: {
      INR: 195715,
      USD: 2544,
    },
    BF: {
      INR: 37006,
      USD: 480,
    },
    BI: {
      INR: 37006,
      USD: 480,
    },
    KH: {
      INR: 104602,
      USD: 1356,
    },
    CA: {
      INR: 31462,
      USD: 408,
    },
    CM: {
      INR: 37006,
      USD: 480,
    },
    TD: {
      INR: 37006,
      USD: 480,
    },
    CL: {
      INR: 185081,
      USD: 2400,
    },
    CN: {
      INR: 104602,
      USD: 1356,
    },
    CO: {
      INR: 7427,
      USD: 96,
    },
    CG: {
      INR: 37006,
      USD: 480,
    },
    CR: {
      INR: 104552,
      USD: 1356,
    },
    HR: {
      INR: 195715,
      USD: 2544,
    },
    CZ: {
      INR: 195715,
      USD: 2544,
    },
    DK: {
      INR: 158078,
      USD: 2052,
    },
    VE: {
      INR: 104552,
      USD: 1356,
    },
    EC: {
      INR: 104552,
      USD: 1356,
    },
    EG: {
      INR: 33331,
      USD: 432,
    },
    SV: {
      INR: 104552,
      USD: 1356,
    },
    ER: {
      INR: 37006,
      USD: 480,
    },
    ET: {
      INR: 37006,
      USD: 480,
    },
    FI: {
      INR: 158078,
      USD: 2052,
    },
    FR: {
      INR: 277785,
      USD: 3600,
    },
    GA: {
      INR: 37006,
      USD: 480,
    },
    GM: {
      INR: 37006,
      USD: 480,
    },
    GE: {
      INR: 195715,
      USD: 2544,
    },
    DE: {
      INR: 509267,
      USD: 6600,
    },
    GH: {
      INR: 37006,
      USD: 480,
    },
    GR: {
      INR: 195715,
      USD: 2544,
    },
    GT: {
      INR: 104552,
      USD: 1356,
    },
    GW: {
      INR: 37006,
      USD: 480,
    },
    HT: {
      INR: 104552,
      USD: 1356,
    },
    HN: {
      INR: 104552,
      USD: 1356,
    },
    HK: {
      INR: 240678,
      USD: 3120,
    },
    HU: {
      INR: 323114,
      USD: 4200,
    },
    IN: {
      INR: 14500,
      USD: 168,
    },
    ID: {
      INR: 231332,
      USD: 3000,
    },
    IQ: {
      INR: 73078,
      USD: 948,
    },
    IE: {
      INR: 158078,
      USD: 2052,
    },
    IL: {
      INR: 49068,
      USD: 636,
    },
    IT: {
      INR: 277532,
      USD: 3600,
    },
    JP: {
      INR: 104602,
      USD: 1356,
    },
    JO: {
      INR: 84179,
      USD: 1092,
    },
    KE: {
      INR: 37006,
      USD: 480,
    },
    KW: {
      INR: 407015,
      USD: 5280,
    },
    LA: {
      INR: 104602,
      USD: 1356,
    },
    LV: {
      INR: 195715,
      USD: 2544,
    },
    LB: {
      INR: 84179,
      USD: 1092,
    },
    LS: {
      INR: 37006,
      USD: 480,
    },
    LR: {
      INR: 37006,
      USD: 480,
    },
    LY: {
      INR: 37006,
      USD: 480,
    },
    LT: {
      INR: 195715,
      USD: 2544,
    },
    MG: {
      INR: 37006,
      USD: 480,
    },
    MW: {
      INR: 37006,
      USD: 480,
    },
    MY: {
      INR: 129610,
      USD: 1680,
    },
    ML: {
      INR: 37006,
      USD: 480,
    },
    MR: {
      INR: 37006,
      USD: 480,
    },
    MX: {
      INR: 78635,
      USD: 1020,
    },
    MD: {
      INR: 195715,
      USD: 2544,
    },
    MN: {
      INR: 104602,
      USD: 1356,
    },
    MA: {
      INR: 212791,
      USD: 2760,
    },
    MZ: {
      INR: 37006,
      USD: 480,
    },
    NA: {
      INR: 37006,
      USD: 480,
    },
    NP: {
      INR: 31474,
      USD: 408,
    },
    NL: {
      INR: 462966,
      USD: 6000,
    },
    NZ: {
      INR: 104602,
      USD: 1356,
    },
    NI: {
      INR: 104552,
      USD: 1356,
    },
    NE: {
      INR: 37006,
      USD: 480,
    },
    NG: {
      INR: 62077,
      USD: 804,
    },
    NO: {
      INR: 158078,
      USD: 2052,
    },
    OM: {
      INR: 228490,
      USD: 2964,
    },
    PK: {
      INR: 138930,
      USD: 1800,
    },
    PA: {
      INR: 104552,
      USD: 1356,
    },
    PG: {
      INR: 104602,
      USD: 1356,
    },
    PY: {
      INR: 104552,
      USD: 1356,
    },
    PE: {
      INR: 277772,
      USD: 3600,
    },
    PH: {
      INR: 104602,
      USD: 1356,
    },
    PL: {
      INR: 112635,
      USD: 1464,
    },
    PT: {
      INR: 158078,
      USD: 2052,
    },
    PR: {
      INR: 104552,
      USD: 1356,
    },
    QA: {
      INR: 111006,
      USD: 1440,
    },
    RO: {
      INR: 267719,
      USD: 3480,
    },
    RU: {
      INR: 370198,
      USD: 4800,
    },
    RW: {
      INR: 37006,
      USD: 480,
    },
    SA: {
      INR: 98944,
      USD: 1284,
    },
    SN: {
      INR: 37006,
      USD: 480,
    },
    RS: {
      INR: 195715,
      USD: 2544,
    },
    SL: {
      INR: 37006,
      USD: 480,
    },
    SG: {
      INR: 148113,
      USD: 1920,
    },
    SK: {
      INR: 195715,
      USD: 2544,
    },
    SI: {
      INR: 195715,
      USD: 2544,
    },
    SO: {
      INR: 37006,
      USD: 480,
    },
    ZA: {
      INR: 88082,
      USD: 1140,
    },
    SS: {
      INR: 37006,
      USD: 480,
    },
    ES: {
      INR: 185005,
      USD: 2400,
    },
    LK: {
      INR: 18516,
      USD: 240,
    },
    SD: {
      INR: 37006,
      USD: 480,
    },
    SE: {
      INR: 158078,
      USD: 2052,
    },
    CH: {
      INR: 158078,
      USD: 2052,
    },
    TW: {
      INR: 104602,
      USD: 1356,
    },
    TJ: {
      INR: 104602,
      USD: 1356,
    },
    TH: {
      INR: 104602,
      USD: 1356,
    },
    TG: {
      INR: 37006,
      USD: 480,
    },
    TN: {
      INR: 37006,
      USD: 480,
    },
    TR: {
      INR: 8336,
      USD: 108,
    },
    TM: {
      INR: 104602,
      USD: 1356,
    },
    UG: {
      INR: 37006,
      USD: 480,
    },
    UA: {
      INR: 275107,
      USD: 3576,
    },
    AE: {
      INR: 145359,
      USD: 1884,
    },
    GB: {
      INR: 203621,
      USD: 2640,
    },
    US: {
      INR: 31462,
      USD: 408,
    },
    UY: {
      INR: 104552,
      USD: 1356,
    },
    UZ: {
      INR: 104602,
      USD: 1356,
    },
    VN: {
      INR: 104602,
      USD: 1356,
    },
    YE: {
      INR: 84179,
      USD: 1092,
    },
    ZM: {
      INR: 37006,
      USD: 480,
    },
    TZ: {
      INR: 37006,
      USD: 480,
    },
    SZ: {
      INR: 37006,
      USD: 480,
    },
    MK: {
      INR: 195715,
      USD: 2544,
    },
    DO: {
      INR: 104552,
      USD: 1356,
    },
    JM: {
      INR: 104552,
      USD: 1356,
    },
    CI: {
      INR: 37006,
      USD: 480,
    },
    OTHER: {
      INR: 71246,
      USD: 924,
    },
    KZ: {
      INR: 166552,
      USD: 2160,
    },
    ZW: {
      INR: 37006,
      USD: 480,
    },
  },
  marketing: {
    AF: {
      INR: 779448,
      USD: 10104,
    },
    AL: {
      INR: 795653,
      USD: 10320,
    },
    DZ: {
      INR: 208358,
      USD: 2700,
    },
    AO: {
      INR: 208358,
      USD: 2700,
    },
    AR: {
      INR: 572051,
      USD: 7416,
    },
    AM: {
      INR: 795653,
      USD: 10320,
    },
    AU: {
      INR: 779448,
      USD: 10104,
    },
    AT: {
      INR: 547865,
      USD: 7104,
    },
    AZ: {
      INR: 795653,
      USD: 10320,
    },
    BH: {
      INR: 363012,
      USD: 4704,
    },
    BD: {
      INR: 677777,
      USD: 8784,
    },
    BY: {
      INR: 795653,
      USD: 10320,
    },
    BE: {
      INR: 547865,
      USD: 7104,
    },
    BJ: {
      INR: 208358,
      USD: 2700,
    },
    BO: {
      INR: 684635,
      USD: 8880,
    },
    BW: {
      INR: 208358,
      USD: 2700,
    },
    BR: {
      INR: 578556,
      USD: 7500,
    },
    BG: {
      INR: 795653,
      USD: 10320,
    },
    BF: {
      INR: 208358,
      USD: 2700,
    },
    BI: {
      INR: 208358,
      USD: 2700,
    },
    KH: {
      INR: 779448,
      USD: 10104,
    },
    CA: {
      INR: 231294,
      USD: 3000,
    },
    CM: {
      INR: 208358,
      USD: 2700,
    },
    TD: {
      INR: 208358,
      USD: 2700,
    },
    CL: {
      INR: 822656,
      USD: 10668,
    },
    CN: {
      INR: 779448,
      USD: 10104,
    },
    CO: {
      INR: 115704,
      USD: 1500,
    },
    CG: {
      INR: 208358,
      USD: 2700,
    },
    CR: {
      INR: 684635,
      USD: 8880,
    },
    HR: {
      INR: 795653,
      USD: 10320,
    },
    CZ: {
      INR: 795653,
      USD: 10320,
    },
    DK: {
      INR: 547865,
      USD: 7104,
    },
    VE: {
      INR: 684635,
      USD: 8880,
    },
    EC: {
      INR: 684635,
      USD: 8880,
    },
    EG: {
      INR: 596023,
      USD: 7728,
    },
    SV: {
      INR: 684635,
      USD: 8880,
    },
    ER: {
      INR: 208358,
      USD: 2700,
    },
    ET: {
      INR: 208358,
      USD: 2700,
    },
    FI: {
      INR: 547865,
      USD: 7104,
    },
    FR: {
      INR: 795564,
      USD: 10308,
    },
    GA: {
      INR: 208358,
      USD: 2700,
    },
    GM: {
      INR: 208358,
      USD: 2700,
    },
    GE: {
      INR: 795653,
      USD: 10320,
    },
    DE: {
      INR: 1263922,
      USD: 16380,
    },
    GH: {
      INR: 208358,
      USD: 2700,
    },
    GR: {
      INR: 795653,
      USD: 10320,
    },
    GT: {
      INR: 684635,
      USD: 8880,
    },
    GW: {
      INR: 208358,
      USD: 2700,
    },
    HT: {
      INR: 684635,
      USD: 8880,
    },
    HN: {
      INR: 684635,
      USD: 8880,
    },
    HK: {
      INR: 677777,
      USD: 8784,
    },
    HU: {
      INR: 795653,
      USD: 10320,
    },
    IN: {
      INR: 109000,
      USD: 1416,
    },
    ID: {
      INR: 380302,
      USD: 4932,
    },
    IQ: {
      INR: 315662,
      USD: 4092,
    },
    IE: {
      INR: 547865,
      USD: 7104,
    },
    IL: {
      INR: 326751,
      USD: 4236,
    },
    IT: {
      INR: 735142,
      USD: 9540,
    },
    JP: {
      INR: 779448,
      USD: 10104,
    },
    JO: {
      INR: 363012,
      USD: 4704,
    },
    KE: {
      INR: 208358,
      USD: 2700,
    },
    KW: {
      INR: 733286,
      USD: 9504,
    },
    LA: {
      INR: 779448,
      USD: 10104,
    },
    LV: {
      INR: 795653,
      USD: 10320,
    },
    LB: {
      INR: 363012,
      USD: 4704,
    },
    LS: {
      INR: 208358,
      USD: 2700,
    },
    LR: {
      INR: 208358,
      USD: 2700,
    },
    LY: {
      INR: 208358,
      USD: 2700,
    },
    LT: {
      INR: 795653,
      USD: 10320,
    },
    MG: {
      INR: 208358,
      USD: 2700,
    },
    MW: {
      INR: 208358,
      USD: 2700,
    },
    MY: {
      INR: 796158,
      USD: 10320,
    },
    ML: {
      INR: 208358,
      USD: 2700,
    },
    MR: {
      INR: 208358,
      USD: 2700,
    },
    MX: {
      INR: 367079,
      USD: 4764,
    },
    MD: {
      INR: 795653,
      USD: 10320,
    },
    MN: {
      INR: 779448,
      USD: 10104,
    },
    MA: {
      INR: 383372,
      USD: 4968,
    },
    MZ: {
      INR: 208358,
      USD: 2700,
    },
    NA: {
      INR: 208358,
      USD: 2700,
    },
    NP: {
      INR: 677777,
      USD: 8784,
    },
    NL: {
      INR: 1478696,
      USD: 19164,
    },
    NZ: {
      INR: 779448,
      USD: 10104,
    },
    NI: {
      INR: 684635,
      USD: 8880,
    },
    NE: {
      INR: 208358,
      USD: 2700,
    },
    NG: {
      INR: 478059,
      USD: 6192,
    },
    NO: {
      INR: 547865,
      USD: 7104,
    },
    OM: {
      INR: 315662,
      USD: 4092,
    },
    PK: {
      INR: 438047,
      USD: 5676,
    },
    PA: {
      INR: 684635,
      USD: 8880,
    },
    PG: {
      INR: 779448,
      USD: 10104,
    },
    PY: {
      INR: 684635,
      USD: 8880,
    },
    PE: {
      INR: 650900,
      USD: 8436,
    },
    PH: {
      INR: 779448,
      USD: 10104,
    },
    PL: {
      INR: 337904,
      USD: 4392,
    },
    PT: {
      INR: 547865,
      USD: 7104,
    },
    PR: {
      INR: 684635,
      USD: 8880,
    },
    QA: {
      INR: 315662,
      USD: 4092,
    },
    RO: {
      INR: 795653,
      USD: 10320,
    },
    RU: {
      INR: 742228,
      USD: 9624,
    },
    RW: {
      INR: 208358,
      USD: 2700,
    },
    SA: {
      INR: 531900,
      USD: 6912,
    },
    SN: {
      INR: 208358,
      USD: 2700,
    },
    RS: {
      INR: 795653,
      USD: 10320,
    },
    SL: {
      INR: 208358,
      USD: 2700,
    },
    SG: {
      INR: 677777,
      USD: 8784,
    },
    SK: {
      INR: 795653,
      USD: 10320,
    },
    SI: {
      INR: 795653,
      USD: 10320,
    },
    SO: {
      INR: 208358,
      USD: 2700,
    },
    ZA: {
      INR: 351380,
      USD: 4548,
    },
    SS: {
      INR: 208358,
      USD: 2700,
    },
    ES: {
      INR: 654247,
      USD: 8484,
    },
    LK: {
      INR: 677777,
      USD: 8784,
    },
    SD: {
      INR: 208358,
      USD: 2700,
    },
    SE: {
      INR: 547865,
      USD: 7104,
    },
    CH: {
      INR: 547865,
      USD: 7104,
    },
    TW: {
      INR: 779448,
      USD: 10104,
    },
    TJ: {
      INR: 779448,
      USD: 10104,
    },
    TH: {
      INR: 779448,
      USD: 10104,
    },
    TG: {
      INR: 208358,
      USD: 2700,
    },
    TN: {
      INR: 208358,
      USD: 2700,
    },
    TR: {
      INR: 100902,
      USD: 1308,
    },
    TM: {
      INR: 779448,
      USD: 10104,
    },
    UG: {
      INR: 208358,
      USD: 2700,
    },
    UA: {
      INR: 795653,
      USD: 10320,
    },
    AE: {
      INR: 531900,
      USD: 6912,
    },
    GB: {
      INR: 587245,
      USD: 7620,
    },
    US: {
      INR: 231294,
      USD: 3000,
    },
    UY: {
      INR: 684635,
      USD: 8880,
    },
    UZ: {
      INR: 779448,
      USD: 10104,
    },
    VN: {
      INR: 779448,
      USD: 10104,
    },
    YE: {
      INR: 363012,
      USD: 4704,
    },
    ZM: {
      INR: 208358,
      USD: 2700,
    },
    TZ: {
      INR: 208358,
      USD: 2700,
    },
    SZ: {
      INR: 208358,
      USD: 2700,
    },
    MK: {
      INR: 795653,
      USD: 10320,
    },
    DO: {
      INR: 684635,
      USD: 8880,
    },
    JM: {
      INR: 684635,
      USD: 8880,
    },
    CI: {
      INR: 208358,
      USD: 2700,
    },
    OTHER: {
      INR: 558853,
      USD: 7248,
    },
    KZ: {
      INR: 558853,
      USD: 7248,
    },
    ZW: {
      INR: 208358,
      USD: 2700,
    },
  },
  marketing_lite: {
    AF: {
      INR: 779448,
      USD: 10104,
    },
    AL: {
      INR: 795653,
      USD: 10320,
    },
    DZ: {
      INR: 208358,
      USD: 2700,
    },
    AO: {
      INR: 208358,
      USD: 2700,
    },
    AR: {
      INR: 572051,
      USD: 7416,
    },
    AM: {
      INR: 795653,
      USD: 10320,
    },
    AU: {
      INR: 779448,
      USD: 10104,
    },
    AT: {
      INR: 547865,
      USD: 7104,
    },
    AZ: {
      INR: 795653,
      USD: 10320,
    },
    BH: {
      INR: 363012,
      USD: 4704,
    },
    BD: {
      INR: 677777,
      USD: 8784,
    },
    BY: {
      INR: 795653,
      USD: 10320,
    },
    BE: {
      INR: 547865,
      USD: 7104,
    },
    BJ: {
      INR: 208358,
      USD: 2700,
    },
    BO: {
      INR: 684635,
      USD: 8880,
    },
    BW: {
      INR: 208358,
      USD: 2700,
    },
    BR: {
      INR: 578556,
      USD: 7500,
    },
    BG: {
      INR: 795653,
      USD: 10320,
    },
    BF: {
      INR: 208358,
      USD: 2700,
    },
    BI: {
      INR: 208358,
      USD: 2700,
    },
    KH: {
      INR: 779448,
      USD: 10104,
    },
    CA: {
      INR: 231294,
      USD: 3000,
    },
    CM: {
      INR: 208358,
      USD: 2700,
    },
    TD: {
      INR: 208358,
      USD: 2700,
    },
    CL: {
      INR: 822656,
      USD: 10668,
    },
    CN: {
      INR: 779448,
      USD: 10104,
    },
    CO: {
      INR: 115704,
      USD: 1500,
    },
    CG: {
      INR: 208358,
      USD: 2700,
    },
    CR: {
      INR: 684635,
      USD: 8880,
    },
    HR: {
      INR: 795653,
      USD: 10320,
    },
    CZ: {
      INR: 795653,
      USD: 10320,
    },
    DK: {
      INR: 547865,
      USD: 7104,
    },
    VE: {
      INR: 684635,
      USD: 8880,
    },
    EC: {
      INR: 684635,
      USD: 8880,
    },
    EG: {
      INR: 596023,
      USD: 7728,
    },
    SV: {
      INR: 684635,
      USD: 8880,
    },
    ER: {
      INR: 208358,
      USD: 2700,
    },
    ET: {
      INR: 208358,
      USD: 2700,
    },
    FI: {
      INR: 547865,
      USD: 7104,
    },
    FR: {
      INR: 795564,
      USD: 10308,
    },
    GA: {
      INR: 208358,
      USD: 2700,
    },
    GM: {
      INR: 208358,
      USD: 2700,
    },
    GE: {
      INR: 795653,
      USD: 10320,
    },
    DE: {
      INR: 1263922,
      USD: 16380,
    },
    GH: {
      INR: 208358,
      USD: 2700,
    },
    GR: {
      INR: 795653,
      USD: 10320,
    },
    GT: {
      INR: 684635,
      USD: 8880,
    },
    GW: {
      INR: 208358,
      USD: 2700,
    },
    HT: {
      INR: 684635,
      USD: 8880,
    },
    HN: {
      INR: 684635,
      USD: 8880,
    },
    HK: {
      INR: 677777,
      USD: 8784,
    },
    HU: {
      INR: 795653,
      USD: 10320,
    },
    IN: {
      INR: 109000,
      USD: 1416,
    },
    ID: {
      INR: 380302,
      USD: 4932,
    },
    IQ: {
      INR: 315662,
      USD: 4092,
    },
    IE: {
      INR: 547865,
      USD: 7104,
    },
    IL: {
      INR: 326751,
      USD: 4236,
    },
    IT: {
      INR: 735142,
      USD: 9540,
    },
    JP: {
      INR: 779448,
      USD: 10104,
    },
    JO: {
      INR: 363012,
      USD: 4704,
    },
    KE: {
      INR: 208358,
      USD: 2700,
    },
    KW: {
      INR: 733286,
      USD: 9504,
    },
    LA: {
      INR: 779448,
      USD: 10104,
    },
    LV: {
      INR: 795653,
      USD: 10320,
    },
    LB: {
      INR: 363012,
      USD: 4704,
    },
    LS: {
      INR: 208358,
      USD: 2700,
    },
    LR: {
      INR: 208358,
      USD: 2700,
    },
    LY: {
      INR: 208358,
      USD: 2700,
    },
    LT: {
      INR: 795653,
      USD: 10320,
    },
    MG: {
      INR: 208358,
      USD: 2700,
    },
    MW: {
      INR: 208358,
      USD: 2700,
    },
    MY: {
      INR: 796158,
      USD: 10320,
    },
    ML: {
      INR: 208358,
      USD: 2700,
    },
    MR: {
      INR: 208358,
      USD: 2700,
    },
    MX: {
      INR: 367079,
      USD: 4764,
    },
    MD: {
      INR: 795653,
      USD: 10320,
    },
    MN: {
      INR: 779448,
      USD: 10104,
    },
    MA: {
      INR: 383372,
      USD: 4968,
    },
    MZ: {
      INR: 208358,
      USD: 2700,
    },
    NA: {
      INR: 208358,
      USD: 2700,
    },
    NP: {
      INR: 677777,
      USD: 8784,
    },
    NL: {
      INR: 1478696,
      USD: 19164,
    },
    NZ: {
      INR: 779448,
      USD: 10104,
    },
    NI: {
      INR: 684635,
      USD: 8880,
    },
    NE: {
      INR: 208358,
      USD: 2700,
    },
    NG: {
      INR: 478059,
      USD: 6192,
    },
    NO: {
      INR: 547865,
      USD: 7104,
    },
    OM: {
      INR: 315662,
      USD: 4092,
    },
    PK: {
      INR: 438047,
      USD: 5676,
    },
    PA: {
      INR: 684635,
      USD: 8880,
    },
    PG: {
      INR: 779448,
      USD: 10104,
    },
    PY: {
      INR: 684635,
      USD: 8880,
    },
    PE: {
      INR: 650900,
      USD: 8436,
    },
    PH: {
      INR: 779448,
      USD: 10104,
    },
    PL: {
      INR: 337904,
      USD: 4392,
    },
    PT: {
      INR: 547865,
      USD: 7104,
    },
    PR: {
      INR: 684635,
      USD: 8880,
    },
    QA: {
      INR: 315662,
      USD: 4092,
    },
    RO: {
      INR: 795653,
      USD: 10320,
    },
    RU: {
      INR: 742228,
      USD: 9624,
    },
    RW: {
      INR: 208358,
      USD: 2700,
    },
    SA: {
      INR: 531900,
      USD: 6912,
    },
    SN: {
      INR: 208358,
      USD: 2700,
    },
    RS: {
      INR: 795653,
      USD: 10320,
    },
    SL: {
      INR: 208358,
      USD: 2700,
    },
    SG: {
      INR: 677777,
      USD: 8784,
    },
    SK: {
      INR: 795653,
      USD: 10320,
    },
    SI: {
      INR: 795653,
      USD: 10320,
    },
    SO: {
      INR: 208358,
      USD: 2700,
    },
    ZA: {
      INR: 351380,
      USD: 4548,
    },
    SS: {
      INR: 208358,
      USD: 2700,
    },
    ES: {
      INR: 654247,
      USD: 8484,
    },
    LK: {
      INR: 677777,
      USD: 8784,
    },
    SD: {
      INR: 208358,
      USD: 2700,
    },
    SE: {
      INR: 547865,
      USD: 7104,
    },
    CH: {
      INR: 547865,
      USD: 7104,
    },
    TW: {
      INR: 779448,
      USD: 10104,
    },
    TJ: {
      INR: 779448,
      USD: 10104,
    },
    TH: {
      INR: 779448,
      USD: 10104,
    },
    TG: {
      INR: 208358,
      USD: 2700,
    },
    TN: {
      INR: 208358,
      USD: 2700,
    },
    TR: {
      INR: 100902,
      USD: 1308,
    },
    TM: {
      INR: 779448,
      USD: 10104,
    },
    UG: {
      INR: 208358,
      USD: 2700,
    },
    UA: {
      INR: 795653,
      USD: 10320,
    },
    AE: {
      INR: 531900,
      USD: 6912,
    },
    GB: {
      INR: 587245,
      USD: 7620,
    },
    US: {
      INR: 231294,
      USD: 3000,
    },
    UY: {
      INR: 684635,
      USD: 8880,
    },
    UZ: {
      INR: 779448,
      USD: 10104,
    },
    VN: {
      INR: 779448,
      USD: 10104,
    },
    YE: {
      INR: 363012,
      USD: 4704,
    },
    ZM: {
      INR: 208358,
      USD: 2700,
    },
    TZ: {
      INR: 208358,
      USD: 2700,
    },
    SZ: {
      INR: 208358,
      USD: 2700,
    },
    MK: {
      INR: 795653,
      USD: 10320,
    },
    DO: {
      INR: 684635,
      USD: 8880,
    },
    JM: {
      INR: 684635,
      USD: 8880,
    },
    CI: {
      INR: 208358,
      USD: 2700,
    },
    OTHER: {
      INR: 558853,
      USD: 7248,
    },
    KZ: {
      INR: 558853,
      USD: 7248,
    },
    ZW: {
      INR: 208358,
      USD: 2700,
    },
  },
  authentication: {
    AF: {
      INR: 104602,
      USD: 1356,
    },
    AL: {
      INR: 195715,
      USD: 2544,
    },
    DZ: {
      INR: 37006,
      USD: 480,
    },
    AO: {
      INR: 37006,
      USD: 480,
    },
    AR: {
      INR: 240754,
      USD: 3120,
    },
    AM: {
      INR: 195715,
      USD: 2544,
    },
    AU: {
      INR: 104602,
      USD: 1356,
    },
    AT: {
      INR: 158078,
      USD: 2052,
    },
    AZ: {
      INR: 195715,
      USD: 2544,
    },
    BH: {
      INR: 84179,
      USD: 1092,
    },
    BD: {
      INR: 34253,
      USD: 444,
    },
    BY: {
      INR: 195715,
      USD: 2544,
    },
    BE: {
      INR: 158078,
      USD: 2052,
    },
    BJ: {
      INR: 37006,
      USD: 480,
    },
    BO: {
      INR: 104552,
      USD: 1356,
    },
    BW: {
      INR: 37006,
      USD: 480,
    },
    BR: {
      INR: 62948,
      USD: 816,
    },
    BG: {
      INR: 195715,
      USD: 2544,
    },
    BF: {
      INR: 37006,
      USD: 480,
    },
    BI: {
      INR: 37006,
      USD: 480,
    },
    KH: {
      INR: 104602,
      USD: 1356,
    },
    CA: {
      INR: 31462,
      USD: 408,
    },
    CM: {
      INR: 37006,
      USD: 480,
    },
    TD: {
      INR: 37006,
      USD: 480,
    },
    CL: {
      INR: 185081,
      USD: 2400,
    },
    CN: {
      INR: 104602,
      USD: 1356,
    },
    CO: {
      INR: 7427,
      USD: 96,
    },
    CG: {
      INR: 37006,
      USD: 480,
    },
    CR: {
      INR: 104552,
      USD: 1356,
    },
    HR: {
      INR: 195715,
      USD: 2544,
    },
    CZ: {
      INR: 195715,
      USD: 2544,
    },
    DK: {
      INR: 158078,
      USD: 2052,
    },
    VE: {
      INR: 104552,
      USD: 1356,
    },
    EC: {
      INR: 104552,
      USD: 1356,
    },
    EG: {
      INR: 33331,
      USD: 432,
    },
    SV: {
      INR: 104552,
      USD: 1356,
    },
    ER: {
      INR: 37006,
      USD: 480,
    },
    ET: {
      INR: 37006,
      USD: 480,
    },
    FI: {
      INR: 158078,
      USD: 2052,
    },
    FR: {
      INR: 277785,
      USD: 3600,
    },
    GA: {
      INR: 37006,
      USD: 480,
    },
    GM: {
      INR: 37006,
      USD: 480,
    },
    GE: {
      INR: 195715,
      USD: 2544,
    },
    DE: {
      INR: 509267,
      USD: 6600,
    },
    GH: {
      INR: 37006,
      USD: 480,
    },
    GR: {
      INR: 195715,
      USD: 2544,
    },
    GT: {
      INR: 104552,
      USD: 1356,
    },
    GW: {
      INR: 37006,
      USD: 480,
    },
    HT: {
      INR: 104552,
      USD: 1356,
    },
    HN: {
      INR: 104552,
      USD: 1356,
    },
    HK: {
      INR: 240678,
      USD: 3120,
    },
    HU: {
      INR: 323114,
      USD: 4200,
    },
    IN: {
      INR: 14500,
      USD: 168,
    },
    ID: {
      INR: 231332,
      USD: 3000,
    },
    IQ: {
      INR: 73078,
      USD: 948,
    },
    IE: {
      INR: 158078,
      USD: 2052,
    },
    IL: {
      INR: 49068,
      USD: 636,
    },
    IT: {
      INR: 277532,
      USD: 3600,
    },
    JP: {
      INR: 104602,
      USD: 1356,
    },
    JO: {
      INR: 84179,
      USD: 1092,
    },
    KE: {
      INR: 37006,
      USD: 480,
    },
    KW: {
      INR: 407015,
      USD: 5280,
    },
    LA: {
      INR: 104602,
      USD: 1356,
    },
    LV: {
      INR: 195715,
      USD: 2544,
    },
    LB: {
      INR: 84179,
      USD: 1092,
    },
    LS: {
      INR: 37006,
      USD: 480,
    },
    LR: {
      INR: 37006,
      USD: 480,
    },
    LY: {
      INR: 37006,
      USD: 480,
    },
    LT: {
      INR: 195715,
      USD: 2544,
    },
    MG: {
      INR: 37006,
      USD: 480,
    },
    MW: {
      INR: 37006,
      USD: 480,
    },
    MY: {
      INR: 129610,
      USD: 1680,
    },
    ML: {
      INR: 37006,
      USD: 480,
    },
    MR: {
      INR: 37006,
      USD: 480,
    },
    MX: {
      INR: 78635,
      USD: 1020,
    },
    MD: {
      INR: 195715,
      USD: 2544,
    },
    MN: {
      INR: 104602,
      USD: 1356,
    },
    MA: {
      INR: 212791,
      USD: 2760,
    },
    MZ: {
      INR: 37006,
      USD: 480,
    },
    NA: {
      INR: 37006,
      USD: 480,
    },
    NP: {
      INR: 31474,
      USD: 408,
    },
    NL: {
      INR: 462966,
      USD: 6000,
    },
    NZ: {
      INR: 104602,
      USD: 1356,
    },
    NI: {
      INR: 104552,
      USD: 1356,
    },
    NE: {
      INR: 37006,
      USD: 480,
    },
    NG: {
      INR: 62077,
      USD: 804,
    },
    NO: {
      INR: 158078,
      USD: 2052,
    },
    OM: {
      INR: 228490,
      USD: 2964,
    },
    PK: {
      INR: 138930,
      USD: 1800,
    },
    PA: {
      INR: 104552,
      USD: 1356,
    },
    PG: {
      INR: 104602,
      USD: 1356,
    },
    PY: {
      INR: 104552,
      USD: 1356,
    },
    PE: {
      INR: 277772,
      USD: 3600,
    },
    PH: {
      INR: 104602,
      USD: 1356,
    },
    PL: {
      INR: 112635,
      USD: 1464,
    },
    PT: {
      INR: 158078,
      USD: 2052,
    },
    PR: {
      INR: 104552,
      USD: 1356,
    },
    QA: {
      INR: 111006,
      USD: 1440,
    },
    RO: {
      INR: 267719,
      USD: 3480,
    },
    RU: {
      INR: 370198,
      USD: 4800,
    },
    RW: {
      INR: 37006,
      USD: 480,
    },
    SA: {
      INR: 98944,
      USD: 1284,
    },
    SN: {
      INR: 37006,
      USD: 480,
    },
    RS: {
      INR: 195715,
      USD: 2544,
    },
    SL: {
      INR: 37006,
      USD: 480,
    },
    SG: {
      INR: 148113,
      USD: 1920,
    },
    SK: {
      INR: 195715,
      USD: 2544,
    },
    SI: {
      INR: 195715,
      USD: 2544,
    },
    SO: {
      INR: 37006,
      USD: 480,
    },
    ZA: {
      INR: 88082,
      USD: 1140,
    },
    SS: {
      INR: 37006,
      USD: 480,
    },
    ES: {
      INR: 185005,
      USD: 2400,
    },
    LK: {
      INR: 18516,
      USD: 240,
    },
    SD: {
      INR: 37006,
      USD: 480,
    },
    SE: {
      INR: 158078,
      USD: 2052,
    },
    CH: {
      INR: 158078,
      USD: 2052,
    },
    TW: {
      INR: 104602,
      USD: 1356,
    },
    TJ: {
      INR: 104602,
      USD: 1356,
    },
    TH: {
      INR: 104602,
      USD: 1356,
    },
    TG: {
      INR: 37006,
      USD: 480,
    },
    TN: {
      INR: 37006,
      USD: 480,
    },
    TR: {
      INR: 8336,
      USD: 108,
    },
    TM: {
      INR: 104602,
      USD: 1356,
    },
    UG: {
      INR: 37006,
      USD: 480,
    },
    UA: {
      INR: 275107,
      USD: 3576,
    },
    AE: {
      INR: 145359,
      USD: 1884,
    },
    GB: {
      INR: 203621,
      USD: 2640,
    },
    US: {
      INR: 31462,
      USD: 408,
    },
    UY: {
      INR: 104552,
      USD: 1356,
    },
    UZ: {
      INR: 104602,
      USD: 1356,
    },
    VN: {
      INR: 104602,
      USD: 1356,
    },
    YE: {
      INR: 84179,
      USD: 1092,
    },
    ZM: {
      INR: 37006,
      USD: 480,
    },
    TZ: {
      INR: 37006,
      USD: 480,
    },
    SZ: {
      INR: 37006,
      USD: 480,
    },
    MK: {
      INR: 195715,
      USD: 2544,
    },
    DO: {
      INR: 104552,
      USD: 1356,
    },
    JM: {
      INR: 104552,
      USD: 1356,
    },
    CI: {
      INR: 37006,
      USD: 480,
    },
    OTHER: {
      INR: 71246,
      USD: 924,
    },
    KZ: {
      INR: 166552,
      USD: 2160,
    },
    ZW: {
      INR: 37006,
      USD: 480,
    },
  },
  utility: {
    AF: {
      INR: 104602,
      USD: 1356,
    },
    AL: {
      INR: 195715,
      USD: 2544,
    },
    DZ: {
      INR: 37006,
      USD: 480,
    },
    AO: {
      INR: 37006,
      USD: 480,
    },
    AR: {
      INR: 240754,
      USD: 3120,
    },
    AM: {
      INR: 195715,
      USD: 2544,
    },
    AU: {
      INR: 104602,
      USD: 1356,
    },
    AT: {
      INR: 158078,
      USD: 2052,
    },
    AZ: {
      INR: 195715,
      USD: 2544,
    },
    BH: {
      INR: 84179,
      USD: 1092,
    },
    BD: {
      INR: 34253,
      USD: 444,
    },
    BY: {
      INR: 195715,
      USD: 2544,
    },
    BE: {
      INR: 158078,
      USD: 2052,
    },
    BJ: {
      INR: 37006,
      USD: 480,
    },
    BO: {
      INR: 104552,
      USD: 1356,
    },
    BW: {
      INR: 37006,
      USD: 480,
    },
    BR: {
      INR: 62948,
      USD: 816,
    },
    BG: {
      INR: 195715,
      USD: 2544,
    },
    BF: {
      INR: 37006,
      USD: 480,
    },
    BI: {
      INR: 37006,
      USD: 480,
    },
    KH: {
      INR: 104602,
      USD: 1356,
    },
    CA: {
      INR: 31462,
      USD: 408,
    },
    CM: {
      INR: 37006,
      USD: 480,
    },
    TD: {
      INR: 37006,
      USD: 480,
    },
    CL: {
      INR: 185081,
      USD: 2400,
    },
    CN: {
      INR: 104602,
      USD: 1356,
    },
    CO: {
      INR: 7427,
      USD: 96,
    },
    CG: {
      INR: 37006,
      USD: 480,
    },
    CR: {
      INR: 104552,
      USD: 1356,
    },
    HR: {
      INR: 195715,
      USD: 2544,
    },
    CZ: {
      INR: 195715,
      USD: 2544,
    },
    DK: {
      INR: 158078,
      USD: 2052,
    },
    VE: {
      INR: 104552,
      USD: 1356,
    },
    EC: {
      INR: 104552,
      USD: 1356,
    },
    EG: {
      INR: 33331,
      USD: 432,
    },
    SV: {
      INR: 104552,
      USD: 1356,
    },
    ER: {
      INR: 37006,
      USD: 480,
    },
    ET: {
      INR: 37006,
      USD: 480,
    },
    FI: {
      INR: 158078,
      USD: 2052,
    },
    FR: {
      INR: 277785,
      USD: 3600,
    },
    GA: {
      INR: 37006,
      USD: 480,
    },
    GM: {
      INR: 37006,
      USD: 480,
    },
    GE: {
      INR: 195715,
      USD: 2544,
    },
    DE: {
      INR: 509267,
      USD: 6600,
    },
    GH: {
      INR: 37006,
      USD: 480,
    },
    GR: {
      INR: 195715,
      USD: 2544,
    },
    GT: {
      INR: 104552,
      USD: 1356,
    },
    GW: {
      INR: 37006,
      USD: 480,
    },
    HT: {
      INR: 104552,
      USD: 1356,
    },
    HN: {
      INR: 104552,
      USD: 1356,
    },
    HK: {
      INR: 240678,
      USD: 3120,
    },
    HU: {
      INR: 323114,
      USD: 4200,
    },
    IN: {
      INR: 14500,
      USD: 168,
    },
    ID: {
      INR: 231332,
      USD: 3000,
    },
    IQ: {
      INR: 73078,
      USD: 948,
    },
    IE: {
      INR: 158078,
      USD: 2052,
    },
    IL: {
      INR: 49068,
      USD: 636,
    },
    IT: {
      INR: 277532,
      USD: 3600,
    },
    JP: {
      INR: 104602,
      USD: 1356,
    },
    JO: {
      INR: 84179,
      USD: 1092,
    },
    KE: {
      INR: 37006,
      USD: 480,
    },
    KW: {
      INR: 407015,
      USD: 5280,
    },
    LA: {
      INR: 104602,
      USD: 1356,
    },
    LV: {
      INR: 195715,
      USD: 2544,
    },
    LB: {
      INR: 84179,
      USD: 1092,
    },
    LS: {
      INR: 37006,
      USD: 480,
    },
    LR: {
      INR: 37006,
      USD: 480,
    },
    LY: {
      INR: 37006,
      USD: 480,
    },
    LT: {
      INR: 195715,
      USD: 2544,
    },
    MG: {
      INR: 37006,
      USD: 480,
    },
    MW: {
      INR: 37006,
      USD: 480,
    },
    MY: {
      INR: 129610,
      USD: 1680,
    },
    ML: {
      INR: 37006,
      USD: 480,
    },
    MR: {
      INR: 37006,
      USD: 480,
    },
    MX: {
      INR: 78635,
      USD: 1020,
    },
    MD: {
      INR: 195715,
      USD: 2544,
    },
    MN: {
      INR: 104602,
      USD: 1356,
    },
    MA: {
      INR: 212791,
      USD: 2760,
    },
    MZ: {
      INR: 37006,
      USD: 480,
    },
    NA: {
      INR: 37006,
      USD: 480,
    },
    NP: {
      INR: 31474,
      USD: 408,
    },
    NL: {
      INR: 462966,
      USD: 6000,
    },
    NZ: {
      INR: 104602,
      USD: 1356,
    },
    NI: {
      INR: 104552,
      USD: 1356,
    },
    NE: {
      INR: 37006,
      USD: 480,
    },
    NG: {
      INR: 62077,
      USD: 804,
    },
    NO: {
      INR: 158078,
      USD: 2052,
    },
    OM: {
      INR: 228490,
      USD: 2964,
    },
    PK: {
      INR: 138930,
      USD: 1800,
    },
    PA: {
      INR: 104552,
      USD: 1356,
    },
    PG: {
      INR: 104602,
      USD: 1356,
    },
    PY: {
      INR: 104552,
      USD: 1356,
    },
    PE: {
      INR: 277772,
      USD: 3600,
    },
    PH: {
      INR: 104602,
      USD: 1356,
    },
    PL: {
      INR: 112635,
      USD: 1464,
    },
    PT: {
      INR: 158078,
      USD: 2052,
    },
    PR: {
      INR: 104552,
      USD: 1356,
    },
    QA: {
      INR: 111006,
      USD: 1440,
    },
    RO: {
      INR: 267719,
      USD: 3480,
    },
    RU: {
      INR: 370198,
      USD: 4800,
    },
    RW: {
      INR: 37006,
      USD: 480,
    },
    SA: {
      INR: 98944,
      USD: 1284,
    },
    SN: {
      INR: 37006,
      USD: 480,
    },
    RS: {
      INR: 195715,
      USD: 2544,
    },
    SL: {
      INR: 37006,
      USD: 480,
    },
    SG: {
      INR: 148113,
      USD: 1920,
    },
    SK: {
      INR: 195715,
      USD: 2544,
    },
    SI: {
      INR: 195715,
      USD: 2544,
    },
    SO: {
      INR: 37006,
      USD: 480,
    },
    ZA: {
      INR: 88082,
      USD: 1140,
    },
    SS: {
      INR: 37006,
      USD: 480,
    },
    ES: {
      INR: 185005,
      USD: 2400,
    },
    LK: {
      INR: 18516,
      USD: 240,
    },
    SD: {
      INR: 37006,
      USD: 480,
    },
    SE: {
      INR: 158078,
      USD: 2052,
    },
    CH: {
      INR: 158078,
      USD: 2052,
    },
    TW: {
      INR: 104602,
      USD: 1356,
    },
    TJ: {
      INR: 104602,
      USD: 1356,
    },
    TH: {
      INR: 104602,
      USD: 1356,
    },
    TG: {
      INR: 37006,
      USD: 480,
    },
    TN: {
      INR: 37006,
      USD: 480,
    },
    TR: {
      INR: 8336,
      USD: 108,
    },
    TM: {
      INR: 104602,
      USD: 1356,
    },
    UG: {
      INR: 37006,
      USD: 480,
    },
    UA: {
      INR: 275107,
      USD: 3576,
    },
    AE: {
      INR: 145359,
      USD: 1884,
    },
    GB: {
      INR: 203621,
      USD: 2640,
    },
    US: {
      INR: 31462,
      USD: 408,
    },
    UY: {
      INR: 104552,
      USD: 1356,
    },
    UZ: {
      INR: 104602,
      USD: 1356,
    },
    VN: {
      INR: 104602,
      USD: 1356,
    },
    YE: {
      INR: 84179,
      USD: 1092,
    },
    ZM: {
      INR: 37006,
      USD: 480,
    },
    TZ: {
      INR: 37006,
      USD: 480,
    },
    SZ: {
      INR: 37006,
      USD: 480,
    },
    MK: {
      INR: 195715,
      USD: 2544,
    },
    DO: {
      INR: 104552,
      USD: 1356,
    },
    JM: {
      INR: 104552,
      USD: 1356,
    },
    CI: {
      INR: 37006,
      USD: 480,
    },
    OTHER: {
      INR: 71246,
      USD: 924,
    },
    KZ: {
      INR: 166552,
      USD: 2160,
    },
    ZW: {
      INR: 37006,
      USD: 480,
    },
  },
};

module.exports = {
  AISENSY_WCC_PLAN,
};
